const customButtonStyle = {
	background: '#FF671D',
	borderRadius: '4px',
	color: '#FFFFFF',
	fontWeight: 'bold',
	border: 'none',
};

export default customButtonStyle;
